import axios from 'axios';

export const downloadReceipt = async (url) => {
  const token = localStorage.getItem('token');
  const res = await axios.get(url, { headers: { Authorization: `Bearer ${token}` }, responseType: 'blob' });
  const name = /filename="([^"]+)"/.exec(res.headers['content-disposition'] || '')?.[1] || 'Ricevuta.pdf';
  const link = document.createElement('a');
  link.href = URL.createObjectURL(res.data);
  link.download = name;
  link.click();
  setTimeout(() => URL.revokeObjectURL(link.href), 1000);
};
